import { render, staticRenderFns } from "./OrderMailReceiver.vue?vue&type=template&id=bae2f00c&"
import script from "./OrderMailReceiver.vue?vue&type=script&lang=js&"
export * from "./OrderMailReceiver.vue?vue&type=script&lang=js&"
import style0 from "./OrderMailReceiver.vue?vue&type=style&index=0&id=bae2f00c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports